import { render } from "./item-gadget.vue?vue&type=template&id=777d943e&scoped=true"
import script from "./item-gadget.vue?vue&type=script&lang=js"
export * from "./item-gadget.vue?vue&type=script&lang=js"

import "./item-gadget.vue?vue&type=style&index=0&id=777d943e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777d943e"]])

export default __exports__